import { gql, useMutation } from '@apollo/client';
import { toLocalDate } from '../../utils/calendarUtility';
import { WorkforceUnitEnum } from '../../enums/WorkforceUnitEnum';

const UPDATE_STAFFING_STATUS = gql`
  mutation UpdateCompanyStaffingStatus(
    $id: Int!
    $status: String!
    $reason: String!
    $startDate: DateTime!
    $endDate: DateTime!
    $workforce: Int
    $workforceUnit: String
  ) {
    updateCompanyStaffingStatus(
      updateCompanyStaffingStatusesArgs: {
        id: $id
        status: $status
        reason: $reason
        startDate: $startDate
        endDate: $endDate
        workforceUnit: $workforceUnit
        workforce: $workforce
      }
    ) {
      message
      status
      statusCode
      error
      data {
        isUpdate
      }
    }
  }
`;

export const useUpdateStaffingStatus = () => {
  const [updateCompanyStaffingStatus, { error, data, loading }] = useMutation(
    UPDATE_STAFFING_STATUS,
  );

  const updateStatus = ({
    id,
    status,
    reason,
    startDate,
    endDate,
    workforce,
    workforceUnit,
    onCompleteCb,
  }: {
    id: number;
    status: string;
    reason: string;
    startDate: Date;
    endDate: Date;
    workforce?: number;
    workforceUnit?: WorkforceUnitEnum;
    onCompleteCb?: (data: any) => any;
  }) => {
    updateCompanyStaffingStatus({
      variables: {
        id,
        status,
        reason,
        startDate: toLocalDate(startDate),
        endDate: toLocalDate(endDate),
        workforce,
        workforceUnit,
      },
      onCompleted: onCompleteCb,
    });
  };

  return { updateStatus, error, data, loading };
};
